import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./TypeMaterials.css";
import axiosInstance from '../../../Config/axiosInstance';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Snackbar, Alert } from '@mui/material';

const AddTypeMaterials = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        code: "",
    });

    //state-uri pentru validare si notificari
    const [titleError, setTitleError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "error"
    });

    //functie pentru verificarea existentei denumirii la submit
    const checkNameExists = async(title) => {
        if(!title.trim()) {
            return false;
        }

        try {
            const response = await axiosInstance.get("/type-materials/check-name/", {
                params: {title: title.trim()}
            });
            return response.data.exists;
        } catch (error) {
            console.error("Error checking name: ", error);
            return false;
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        //reseteaza eroarea cand utilizatorul modifica campul name
        if(name === "name") {
            setTitleError("");
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({...snackbar, open: false});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        //prevenim submit ul multiplu
        if(isSubmitting) return;
        //verificam daca numele exista deja
        setIsSubmitting(true);

        try {
           const nameExists = await checkNameExists(formData.name);
           if(nameExists) {
            //setam eroarea pentru campul name
            setTitleError("A material type with this quality already exists in the system!")
            //afisam snackbar cu mesaj de eroare
            setSnackbar({
                open: true,
                message: "A material quality with this name already exists. Please enter a unique name!",
                severity: "error"
            });

            setIsSubmitting(false);
            return;
           }

           //daca numele nu exista trimitem datele 
           const typeMaterialsResponse = await axiosInstance.post("/type-materials/", formData);
           console.log("Created successfully: ", typeMaterialsResponse.data);

           //afisam un mesaj de succes
           setSnackbar({
            open: true, 
            message: "The material type was created successfully!",
            severity: "success"
           })

           //navigam inapoi dupa un scurt delay pentru a permite afisarea mesajului
           setTimeout(() => {
            navigate(-1);
           }, 1500);
        } catch (error) {
            console.error("Error creating types of materials:", error.response?.data || error.message);
            //verificam daca eroarea vine din backend
            if(error.response?.data?.name) {
                setTitleError("A material type with this quality already exists in the system!")
                setSnackbar({
                    open: true,
                    message: "A material quality with this name already exists. Please enter a unique name!", 
                    severity: error
                });
            } else {
                setSnackbar({
                    open: true, 
                    message: "An error occurred while saving the data.",
                    severity: "error"
                });
            }
            setIsSubmitting(false);
        }
    };

    return (
        <>
        <div className='materials-page'>
            <div className="add-materials-container">
                <div className="materials-header">
                    <ArrowBackIcon className="back-arrow" onClick={() => navigate(-1)} />
                    <h2 className="add-materials-title">Add Type of Materials</h2>
                </div>
            </div>

            <hr className="title-separator" />

            <div className="add-materials-container">
                <form onSubmit={handleSubmit} className="add-materials-form">
                    <div className="form-group">
                        <label htmlFor="name" className="label">
                            Quality of material<span className='required-star'>*</span>
                        </label>
                        <input
                            id="name"
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="input"
                            required
                        />
                        {titleError && (
                            <div className='error-message' style={{color: '#d32f2f', fontSize: '0.875rem'}}>
                            {titleError}
                            </div>
                        )}
                    </div>

                    <div className="form-group">
                        <label htmlFor="code" className="label">
                            Standard<span className='required-star'>*</span>
                        </label>
                        <input
                            id="code"
                            type="text"
                            name="code"
                            value={formData.code}
                            onChange={handleChange}
                            className="input"
                            required
                        />
                    </div>
                    
                    <button 
                    type="submit" 
                    className="button-save"
                    disabled={isSubmitting}
                    >
                        {isSubmitting ? "Saving..." : "Save"}
                    </button>
                </form>
            </div>
        </div>

        {/*snackbar pentru notificari*/}
        <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            <Alert
                onClose={handleCloseSnackbar}
                severity={snackbar.severity}
                sx={{width: '100%'}}
            >
                {snackbar.message}
            </Alert>
        </Snackbar>
        </>
    );
};

export default AddTypeMaterials;
